import { hyphenateHTMLSync } from "hyphen/fi"
import React from "react"

import styles from "./IconGridLink.module.scss"

const IconGridLink = ({ icon, href, text, target, element }) => {
  const Element = element
  return (
    <Element className={styles.item}>
      <a
        href={href}
        target={target}
        rel={`${target === "_blank" ? "noopener noreferrer" : ""}`}
      >
        {icon && (
          <img
            className={styles.icon}
            src={icon}
            width="40"
            height="40"
            alt=""
            aria-hidden="true"
          />
        )}
        <span>
          {text ? hyphenateHTMLSync(text, { minWordLength: 16 }) : ""}
        </span>
      </a>
    </Element>
  )
}

IconGridLink.defaultProps = {
  element: "li",
}

export default IconGridLink
